import type { UserId } from '../../types';

export const isAuthorizedUserId = (userId: UserId) => {
    // вынесено отдельно, чтобы контролировать -
    // какие именно значения фоллбэчим до UNAUTHORIZED_USER
    // дада, это эквивалентно !!userId
    // eslint-disable-next-line
    return (
        userId !== null &&
        userId !== undefined &&
        userId !== '' &&
        userId !== 0
    );
};
